<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap align-end>
        <v-flex xs6 md7 lg9>
          <card-menu :items="cardMenu" @cardReturn="visibleControl" subMenu></card-menu>
        </v-flex>
        <v-flex xs3>
          <v-container fluid class="pa-0" align="right">
            <span align="right">
              <div class="text-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" fab dark color="error" v-on="on" @click.native="doButtons('delete')"><v-icon dark>mdi-delete</v-icon></v-btn>
                  </template>
                  <span>Delete Treaty</span>
                </v-tooltip>
              </div>
            </span>
          </v-container>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <form data-vv-scope="treatyForm">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div>
                    <v-icon>mdi-filter-variant</v-icon>
                    Filters for {{ listMode }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg4 xs6>
                          <v-autocomplete
                            :items="stmtTypeList"
                            v-model="filters.stmtType"
                            :label="filtersLabel.stmtType"
                            item-text="label"
                            item-value="value"
                            data-vv-name="stmtType"
                            :data-vv-as="filtersLabel.stmtType"
                            :error-messages="errors.collect('stmtType')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <v-text-field
                            v-model="filters.ttyRef"
                            :label="filtersLabel.ttyRef"
                            :error-messages="errors.collect('ttyRef')"
                            data-vv-name="ttyRef"
                            :data-vv-as="filtersLabel.ttyRef"
                            v-validate="'entry|max:16'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <v-text-field
                            v-model="filters.ttyDesc"
                            :label="filtersLabel.ttyDesc"
                            :error-messages="errors.collect('ttyDesc')"
                            data-vv-name="ttyDesc"
                            :data-vv-as="filtersLabel.ttyDesc"
                            v-validate="'entry|max:16'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <v-text-field
                            v-model="filters.stmtRef"
                            :label="filtersLabel.stmtRef"
                            :error-messages="errors.collect('stmtRef')"
                            data-vv-name="stmtRef"
                            :data-vv-as="filtersLabel.stmtRef"
                            v-validate="'entry|max:16'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <v-text-field
                            v-model="filters.tranRef"
                            :label="filtersLabel.tranRef"
                            :error-messages="errors.collect('tranRef')"
                            data-vv-name="tranRef"
                            :data-vv-as="filtersLabel.tranRef"
                            v-validate="'entry|max:16'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <v-autocomplete
                            :items="validYrList"
                            v-model="filters.uwYr"
                            :label="filtersLabel.uwYr"
                            item-text="label"
                            item-value="value"
                            data-vv-name="uwYr"
                            :data-vv-as="filtersLabel.uwYr"
                            :error-messages="errors.collect('uwYr')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <cal-picker
                            v-model="filters.tranDate"
                            :label="filtersLabel.tranDate"
                            :data-vv-as="filtersLabel.tranDate"
                            data-vv-name="tranDate"
                          ></cal-picker>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <v-autocomplete
                            :items="mthList"
                            v-model="filters.acctMth"
                            :label="filtersLabel.acctMth"
                            item-text="label"
                            item-value="value"
                            data-vv-name="acctMth"
                            :data-vv-as="filtersLabel.acctMth"
                            :error-messages="errors.collect('acctMth')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <v-autocomplete
                            :items="validYrList"
                            v-model="filters.acctYr"
                            :label="filtersLabel.acctYr"
                            item-text="label"
                            item-value="value"
                            data-vv-name="acctYr"
                            :data-vv-as="filtersLabel.acctYr"
                            :error-messages="errors.collect('acctYr')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-flex class="text-right">
              <v-btn class="mr-2" color="primary" @click.native="doCreate()">
                <span>New Treaty Statement</span>
                <v-icon right dark>mdi-plus</v-icon>
              </v-btn>
              <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
                <template v-slot:activator="{ on }">
                  <v-btn color="secondary" class="white--text mr-2" v-on="on">
                    <span>Columns</span>
                    <v-icon right dark>mdi-table-column-plus-after</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-text>
                    <template v-if="columns.length > 0">
                      <v-checkbox
                        v-for="column in columns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else>No column found</template>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-data-table
                  :headers="listHeaders"
                  :items="treatyMasterList"
                  :server-items-length="totalItems"
                  :footer-props="{'items-per-page-options': itemsPerPage }"
                  v-bind:options.sync="pagination"
                  item-key="polNo"
                  :loading="loading"
                  :no-data-text="noDataText"
                  :custom-filter="customSearch"
                >
                  <template v-slot:item="row"
                    ><tr>
                      <td v-for="column in selectedColumns" :key="column">{{ row.item[column] }}</td>
                      <td class="table-action-header">
                        <table-action
                          v-if="listMode === 'Delete Treaty'"
                          :rowData="row"
                          :review="canReview(row.item)"
                          @review="doReview(row.item)"
                          query
                          @query="doQuery(row.item)"
                          remove
                          @remove="doPromptRemove(row.item)"
                          :loading="loading"
                        ></table-action>
                        <table-action
                          v-else
                          :rowData="row"
                          :review="canReview(row.item)"
                          @review="doReview(row.item)"
                          query
                          @query="doQuery(row.item)"
                          :loading="loading"
                        ></table-action>
                      </td></tr
                  ></template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <!--Start Delete Prompt -->
    <confirm v-model="promptRemove" @ok="doDelete">
      <p>{{ labels.promptRemove }}</p>
      <div class="queryValue">{{ deleteTtyMaster }}</div>
    </confirm>
    <!-- End Delete Prompt-->
    <v-dialog v-model="loadingFlag" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import clone from 'clone'
import { listMixin } from '@/mixins/listMixin'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { tgtMth } from '@/const/params'
import { treatyAjaxMixin } from '@/mixins/treaty/treatyAjaxMixin'
import { treatyListMixin } from '@/mixins/treaty/treatyListMixin'
import { formatDisplayDateTime2, removeTime } from '@/utils/date'

export default {
  data() {
    return {
      cardMenu: [
        { text: 'Statement', icon: 'mdi-file', name: '', params: { tab: 'statement' }, access: '', default: true },
        { text: 'Release', icon: 'mdi-file-multiple', name: '', params: { tab: 'release' }, access: '' }
      ],
      visibleTab: {},
      tab: undefined,
      filtersLabel: {
        stmtType: 'Statement Type',
        ttyRef: 'Treaty Ref',
        ttyDesc: 'Treaty Name', // From xTreaty.ttyDesc
        stmtRef: 'Statement Reference',
        tranRef: 'Transaction Reference',
        uwYr: 'Underwriting Year',
        tranDate: 'Transaction Date',
        acctYr: 'Accounting Year',
        acctMth: 'Accounting Month'
      },
      labels: {
        promptRemove: 'Are you sure you want to delete the selected Treaty Master.'
      },
      filters: {
        review: 'statement',
        stmtType: undefined,
        ttyRef: undefined,
        ttyDesc: undefined,
        stmtRef: undefined,
        tranRef: undefined,
        uwYr: undefined,
        tranDate: undefined,
        acctYr: undefined,
        acctMth: undefined
      },
      treatyMasterList: [],
      stmtTypeList: [],
      validYrList: [],
      selectedColumns: ['ttyRef', 'stmtType', 'tranDateDisp', 'stmtRef', 'tranRef', 'ttyDesc', 'uwYr', 'acctYr', 'acctMth', 'curr', 'tranRelDisp'],
      columns: [
        { text: 'Treaty Ref', value: 'ttyRef' },
        { text: 'Stmt Type', value: 'stmtType' },
        { text: 'Tran Date', value: 'tranDateDisp' },
        { text: 'Stmt Ref', value: 'stmtRef' },
        { text: 'Tran Ref', value: 'tranRef' },
        { text: 'Treaty Name', value: 'ttyDesc' },
        { text: 'UW Yr', value: 'uwYr' },
        { text: 'Acct Yr', value: 'acctYr' },
        { text: 'Acct Mth', value: 'acctMth' },
        { text: 'Curr', value: 'curr' },
        { text: 'Rel', value: 'tranRelDisp' },
        { text: 'Desc', value: 'ttyStmtDesc' }
      ],
      promptRemove: false,
      selectedTtyMaster: undefined,
      deleteTtyMaster: undefined,
      loadingFlag: false,
      query: false,
      listMode: 'Statement',
      pagination: {
        sortDesc: [true],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('treatyMasterInit')])
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.pagination.sortBy = ['tranDateDisp']
      this.pagination.sortDesc = [true]
      this.getCommonDataList('stmtTypeList')
      this.getValidYrList()
      this.fetchData()
    },
    visibleControl(data) {
      if (typeof data !== 'undefined') {
        this.visibleTab = { ...data }
        this.doButtons(this.visibleTab.tab)
      } else {
        this.visibleTab = {}
      }
    },
    doButtons(data) {
      this.filters.review = data
      if (data === 'statement') {
        this.listMode = 'Statement'
        this.fetchData(data)
      } else if (data === 'release') {
        this.listMode = 'Release'
        this.fetchData(data)
      } else if (data === 'delete') {
        this.listMode = 'Delete Treaty'
        this.fetchData()
      } else {
        // this.fetchData(false)
      }
    },
    getValidYrList() {
      var currYr = new Date()
      this.validYrList.push(
        { label: currYr.getFullYear() - 1, value: currYr.getFullYear() - 1 },
        { label: currYr.getFullYear(), value: currYr.getFullYear() },
        { label: currYr.getFullYear() + 1, value: currYr.getFullYear() + 1 }
      )
    },
    doClearFilters() {
      var thisPage = this

      // Iterate through each object field, key is name of the object field
      Object.keys(this.filters).forEach(function (key, index) {
        if (index === 0) {
          thisPage.filters[key] = thisPage.listMode.toLowerCase()
        } else {
          thisPage.filters[key] = ''
        }
      })
      this.fetchData()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('treatyForm').then((result) => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData()
        }
      })
    },
    async fetchData() {
      let apiUrl = this.menu.getTreatyMasterList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let massageFilters = clone(this.filters)
          if (massageFilters.tranDate) {
            massageFilters.tranDate = formatDisplayDateTime2(removeTime(massageFilters.tranDate))
          }
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              this.treatyMasterList = []
              data.map((ttyMaster) => {
                const convertTtyMaster = {
                  riType: ttyMaster.riType,
                  ttyRef: ttyMaster.ttyRef,
                  ttyDesc: ttyMaster.ttyDesc,
                  stmtType: ttyMaster.stmtType,
                  tranDate: ttyMaster.tranDate,
                  tranDateDisp: this.formatDate(ttyMaster.tranDate),
                  tranRel: ttyMaster.tranRel,
                  stmtRef: ttyMaster.stmtRef,
                  tranRef: ttyMaster.tranRef,
                  uwYr: ttyMaster.uwYr,
                  acctYr: ttyMaster.acctYr,
                  acctMth: ttyMaster.acctMth,
                  curr: ttyMaster.curr,
                  tranRelDisp: ttyMaster.tranRelDisp
                }
                this.treatyMasterList.push(convertTtyMaster)
              })
            } else {
              this.treatyMasterList = []
            }
          }
          this.loading = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.loading = false
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doCreate() {
      this.$router.push({ name: 'treatyHeader', params: { mode: 'new' } })
    },
    async doReview(data) {
      this.$router.push({ name: 'treatyHeader', params: { mode: 'review', selectedTty: data } })
    },
    async doQuery(data) {
      this.$router.push({ name: 'treatyHeader', params: { mode: 'query', selectedTty: data } })
    },
    async doDelete() {
      this.loadingFlag = true
      const apiUrl = this.menu.deleteTtyMaster
      if (apiUrl) {
        try {
          const expand = this.selectedTtyMaster
          const result = await this.$http.post(apiUrl, expand)
          const data = result.data
          if (data) {
            this.notify(data)
            this.fetchData()
            this.loadingFlag = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.loadingFlag = false
        // const expand = this.selectedTtyMaster
        // await this.$http.post(apiUrl, expand).then(result => {
        //   const data = result.data
        //   this.notify(data)
        // }).catch(err => {
        //   const { data } = err.response
        //   if (data) {
        //     this.message(data)
        //   }
        // })
      }
    },
    doPromptRemove(item) {
      this.promptRemove = true
      this.labels.promptRemove = 'You have chosen to delete this record. Do you really want to delete this record?'
      this.selectedTtyMaster = item
      this.deleteTtyMaster = item.riType + ' - ' + item.ttyRef + ' - ' + item.uwYr + ' - ' + item.tranDateDisp + ' - ' + item.tranRef
    },
    canReview(data) {
      if (data.tranRel === false) {
        return true
      } else {
        return false
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.treatyAcct.treatyMaster.menu
    },
    mthList() {
      let result = []
      Object.keys(tgtMth).forEach(function (key) {
        const status = tgtMth[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  created() {
    this.doInit()
  },
  mixins: [listMixin, MessageMixin, commonAjaxMixin, treatyAjaxMixin, treatyListMixin]
}
</script>
